import React from "react";
import Style from "../assets/styles/privacy.module.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <main className={Style.main}>
        <h1>Privacy Policy</h1>
        <p>
          <strong>Effective Date:</strong> 10th July, 2024
        </p>
        <h2>PIXELLAB IS COMMITTED TO YOUR PRIVACY</h2>
        <p>
          We value Your patronage and respect Your privacy rights. As part of
          the normal operation of Our services, We collect and, in some cases,
          may disclose information about You. We have created the following
          Privacy Policy to let You know what information We collect when You
          use Our Service, why We collect it, and how it is used. This Privacy
          Policy applies to all information that You provide to PixelLab Ltd.
          ("Us," "We," or "Our") and that We maintain electronically, whether
          You provide the information through Our Service located at{" "}
          <a href="http://www.pixellabltd.com">www.pixellabltd.com</a> (the
          "Website"), or via any applications created by PixelLab Ltd. ("Apps"),
          and information made available by users to each other through the
          PixelLab Ltd. Software (collectively, the "Service"). Additionally,
          this Privacy Policy applies to any Personal Information (defined
          below) obtained from Your use of the Service. This Privacy Policy does
          not apply to any information that You may provide to third parties;
          for example, other sites linked to this Website and Apps. You should
          contact such third parties directly to determine their respective
          privacy policies. This Privacy Policy is governed by Our Terms and
          Conditions. PixelLab Ltd. reserves the right to change this Privacy
          Policy at any time without notice. Please check the privacy policy
          regularly. If You do not expressly object to the validity of the new
          terms and conditions/privacy Policy via e-mail within this two (2)
          week period, then the newly revised Privacy Policy will be considered
          agreed upon. If You reject the newly revised Privacy Policy, then
          PixelLab Ltd. may terminate its relationship with You. If You believe
          We have not adhered to this Privacy Policy or if You have any other
          questions regarding this Privacy Policy, please contact Us at{" "}
          <a href="mailto:shohan@pixellabltd.com">shohan@pixellabltd.com</a>.
        </p>

        <h2>WHICH DATA ARE WE COLLECTING?</h2>
        <p>
          Data We are collecting are either provided by You or collected
          automatically.
        </p>
        <p>
          <strong>Data You provide Us:</strong>
        </p>
        <ul>
          <li>Data that You provide during registration</li>
          <li>
            Data that You provide for the billing of goods and services
            requiring payment
          </li>
        </ul>
        <p>
          <strong>Data We collect automatically:</strong>
        </p>
        <ul>
          <li>Data about Your game progress</li>
          <li>
            Data about Your device, such as device name and operating system
          </li>
          <li>General location data</li>
          <li>Data about Your use of the Service such as game-play data</li>
          <li>
            Data we receive if you link a third party tool with the Service
            (such as Facebook or Google)
          </li>
        </ul>
        <p>
          Furthermore We collect and store information in the log files of our
          servers which are automatically transferred to us by Your Internet
          browser (i.e. without us requesting this data). This data among others
          includes:
        </p>
        <ul>
          <li>Browser type and version</li>
          <li>Operating system</li>
          <li>Device type</li>
          <li>Referrer URL (the previously visited site)</li>
          <li>IP address of the accessing computer</li>
          <li>Cookies</li>
          <li>Time of the server request</li>
        </ul>
        <p>
          Data collected automatically cannot be assigned to certain individuals
          by us. We use it in a pseudonymous and/or anonymous form for analytic
          purposes and to tailor and improve our Service according to the needs
          of the user. This data will not be combined with other data sources.
        </p>
        <p>
          We process and use data You provide Us for providing the game Service
          or create accounts and allow you to use our Service and for billing
          our Services as well as for advertising purposes. In individual cases,
          We shall commission related companies or other third parties to
          provide services. This particularly applies to the handling of
          payments via external service providers (PayPal, Global Collect, etc.)
          as well as to collection agencies in the case of late payments. These
          external companies are obligated to treat Your data confidentially and
          safely to the extent required in fulfilling their duties.
        </p>
        <p>
          Data in our Apps are collected through third party services. For more
          information about their privacy policies and opt-out possibilities,
          please visit the links below.
        </p>
        <ul>
          <li>
            <a href="https://policies.google.com/privacy">
              Google Play Services
            </a>
          </li>
          <li>
            <a href="https://firebase.google.com/policies/analytics">
              Firebase Analytics
            </a>
          </li>
          <li>
            <a href="https://unity3d.com/legal/privacy-policy">Unity</a>
          </li>
          <li>
            <a href="https://privacy.microsoft.com/en-us/privacystatement">
              Playfab
            </a>
          </li>
          <li>
            <a href="https://www.singular.net/privacy-policy/">Singular</a>
          </li>
          <li>
            <a href="https://www.facebook.com/policy.php">Meta</a>
          </li>
          <li>
            <a href="https://policies.google.com/privacy">Google</a>
          </li>
        </ul>

        <h2>USE OF COOKIES</h2>
        <p>
          The game as well as the related Internet pages uses so-called Cookies
          or Flash Cookies (Local Shares Object) at multiple points. Cookies
          serve to make our offer more user-friendly and effective. Cookies are
          small text files placed on Your computer and stored by Your browser.
          By itself, cookies cannot be used to identify the user. Cookies do not
          cause harm to Your computer and do not contain viruses. The game as
          well as the related Internet pages can be used without Cookies, if the
          web browser is set in such a manner that cookies are generally denied
          or You are notified if a cookie is received, thus allowing You to
          decide every time whether You would like to accept it or not. You can
          manually delete cookies that are already on Your computer at any time
          from the hard drive. Please note that usage of the game and the
          related Internet pages without cookies may only be possible with
          limitations.
        </p>
        <p>
          We also work with a third party ad networks within our Service. These
          networks can use cookies, web beacons, and other tracking technologies
          to collect or receive data about You and might claim controller rights
          over Your personal data. For more information about their privacy
          policies and opt-out possibilities, please visit the links below.
        </p>
        <ul>
          <li>
            <a href="https://unity3d.com/legal/privacy-policy">Unity</a>
          </li>
          <li>
            <a href="https://developers.ironsrc.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/">
              IronSource
            </a>
          </li>
          <li>
            <a href="https://policies.google.com/privacy">Admob</a>
          </li>
          <li>
            <a href="https://www.facebook.com/policy.php">Meta</a>
          </li>
          <li>
            <a href="https://www.bidstack.com/privacy-policy/">Bidstack</a>
          </li>
          <li>
            <a href="https://www.anzu.io/privacy-policy">Anzu</a>
          </li>
        </ul>
        <p>
          If You would like to limit targeted advertising, You can do so by
          limiting ad tracking in Your device settings. For mobile advertising
          in apps, You can reset Your Advertising Identifier and depending on
          Your device, select to opt out of interest-based ads (Android) or turn
          on the Limit Ad Tracking setting (iOS). For advertising on the Web,
          You can also adjust Your browser settings to limit cookies, and by
          visiting the following sites:{" "}
          <a href="http://www.aboutads.info/choices">
            http://www.aboutads.info/choices
          </a>{" "}
          and{" "}
          <a href="http://www.youronlinechoices.eu/">
            http://www.youronlinechoices.eu/
          </a>
          .
        </p>

        <h2>SPECIAL NOTE ABOUT CHILDREN</h2>
        <p>
          This Service is targeted primarily for use by adults. We do not
          currently market to or create special areas for use by children.
          Accordingly, We do not knowingly collect age identifying information,
          nor do We knowingly collect any Personal Information from children
          under the age of 13 years. However, We hereby advise all visitors to
          Our site under the age of 13 not to disclose or provide any Personal
          Information on Our Service. In the event that We discover that a child
          under the age of 13 has provided Personal Information to Us, in
          accordance with the Children's Online Privacy Protection Act (please
          see the Federal Trade Commission's Website at{" "}
          <a href="http://www.ftc.gov/kidzprivacy">www.ftc.gov/kidzprivacy</a>{" "}
          for more information about this Act), We will delete the child's
          Personal Information from Our files to the extent technologically
          possible.
        </p>

        <h2>HOW WE USE YOUR INFORMATION</h2>
        <p>
          The information We collect is used to (i) to respond to Your
          inquiries; (ii) provide customer services and resolve any complaints;
          (iii) improve the Service and resolve any technical problems; (iv)
          communicate with You concerning the usage of Our Services provided by
          Us or any of Our Partners; (v) cross-reference with other Personal
          Information that We have acquired about You or may acquire about You
          through other sources; (vi) create aggregate data; (vii) ensure
          compliance with the Service Terms of use; (viii) send You
          communication about Our services and promotions if applicable; and
          (ix) comply with any applicable laws and regulations. We may provide
          Your information to government officials and agencies as required by
          law, and Partners as part of business operations, transaction
          processing, and marketing efforts, as identified below. For purposes
          of this Privacy Policy, "Partner" shall mean any person or entity with
          whom We enter into any kind of business transaction who is under an
          obligation to Us to use reasonable care to keep Personal Information
          confidential.
        </p>

        <h2>DISCLOSURE OF INFORMATION WE COLLECT</h2>
        <p>
          Except as provided in this Privacy Policy, We will not sell, trade, or
          disclose to third parties any Personal Information obtained by Us
          through this Service or from Our Partners about You, without Your
          consent. We may disclose Personal Information (i) to companies that
          help process the transactions You request, in order to protect Your
          transactions from fraud and verify Your identity; (ii) that We in good
          faith believe is necessary or appropriate to cooperate in
          investigations of fraud, intellectual property infringements or other
          activity that is illegal or may expose Us or You to legal liability,
          or to conduct investigations of violations of the Service Terms of
          use; (iii) when required by law or to comply with a court order,
          subpoena, search warrant or other legal process; (iv) to comply with
          legal, regulatory or administrative requirements of governmental
          authorities (including, without limitation, requests from the
          governmental agency authorities to view Your Personal Information);
          (v) to protect and defend Us, Our subsidiaries and affiliates and any
          of their officers, directors, employees, attorneys, agents,
          contractors and partners, in connection with any legal action, claim
          or dispute; (vi) to prevent imminent physical harm; (vii) to share
          aggregated statistical or demographic data with Our affiliates,
          business partners or for public relations (this aggregated information
          is not tied to Personal Information); (viii) to provide data,
          including Personal Information about You, with Our parent, affiliates,
          subsidiaries and Partners; (ix) to sell or otherwise provide to third
          parties in the event of a bankruptcy or liquidation; and (x) to sell
          or otherwise provide to third parties in the event of a future merge
          or acquisition by another company. In the event We merge or are
          acquired by another company, the successor company will have access to
          Your Personal Information in order to continue to provide services,
          but would continue to be bound by this Privacy Policy unless and until
          it is amended as described in the subsection labeled "Changes to this
          Privacy Policy" below.
        </p>

        <h2>HOW WE PROTECT INFORMATION WE COLLECT</h2>
        <p>
          We offer secure web pages to collect certain kinds of user information
          and We store certain kinds of data in encrypted form. We follow
          reasonable technical and management practices to help protect the
          confidentiality, security and integrity of data stored on Our system.
          Although no computer system is completely secure, We believe the
          measures implemented on Our Website and through Our Service reduce the
          likelihood of security problems to a level appropriate to the type of
          data involved.
        </p>

        <h2>PERSONAL CHOICE IN THE DISCLOSURE OF YOUR INFORMATION</h2>
        <p>
          You have right to have Your data deleted, object how We use Your data,
          or restrict how We share Your data. In any of these cases You can
          contact Us by sending an email to Us at{" "}
          <a href="mailto:shohan@pixellabltd.com">shohan@pixellabltd.com</a>{" "}
          or write Us at:
        </p>
        <p>
          PixelLab Ltd.
          <br />
          Pallabi, Estern Housing
          <br />
        </p>
        <p>
          If You do not want to receive certain communications and offers from
          Us You can "opt out" of such sharing, communications and offers also
          by contacting Us. If You believe that any Personal Information
          collected by Us about You is not correct or has changed, please send
          an e-mail message to{" "}
          <a href="mailto:shohan@pixellabltd.com">shohan@pixellabltd.com</a>{" "}
          explaining the correction or change and providing any relevant
          confirmation or reference number.
        </p>

        <h2>CHANGES TO THIS PRIVACY POLICY</h2>
        <p>
          By Using this Service, You agree to this Privacy Policy. We reserve
          the right to change, modify or amend this Privacy Policy at any time.
          Any revised Privacy Policy will only apply prospectively to Personal
          Information collected or modified after the effective date of the
          revised policy.
        </p>

        <h2>IF YOU HAVE A PRIVACY QUESTION</h2>
        <p>
          If You have a privacy question about this Website, please email
          Customer Service at{" "}
          <a href="mailto:shohan@pixellabltd.com">shohan@pixellabltd.com</a>
        </p>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
